module.exports = __webpack_public_path__ + "static/media/Icon 6.f7b4246e.png";